<template>
  <div class="preview">
    <div class="controls">
      <textbook-category-select
        :key="courseTypeCode + '-' + categoryCode + '-' + textbookVersion"
        :course-type-code="courseTypeCode"
        :category-code="categoryCode"
        :version="textbookVersion"
        @change="selectLevels"
      />

      <el-form
        ref="form"
        class="select-course"
        label-width="80px"
      >
        <el-form-item
          ref="courseSelectForm"
          label="课程"
        >
          <el-cascader
            v-model="levelAndCourse"
            style="min-width: 620px"
            filterable
            :props="selectionProps"
            :options="levels"
            @change="selectTextbook"
          >
            <template slot-scope="{ node, data }">
              <span style="float: left">{{ data.name }}</span>
              <span
                v-if="data.isUsed === 0"
                style="float: right; color: #8492a6; font-size: 13p"
              >{{ $t("禁用") }}</span>
            </template>
          </el-cascader>
        </el-form-item>
      </el-form>

      <div class="add">
        <el-button
          v-if="$hasPermission('previewCreate')"
          icon="el-icon-plus"
          size="small"
          :disabled="!$route.query.courseId"
          @click="
            $router.push({
              name: 'previewAdd',
              params: { courseId: $route.query.courseId },
            })
          "
        >
          新增试卷
        </el-button>
      </div>
    </div>

    <el-table
      :data="previewVersions"
      style="width: 100%"
    >
      <el-table-column
        fixed
        label="online"
        width="70"
      >
        <template slot-scope="scope">
          <div
            :class="{ online: scope.row.online, offline: !scope.row.online }"
          />
        </template>
      </el-table-column>
      <el-table-column
        fixed
        prop="version"
        label="版本号"
        width="80"
      />
      <el-table-column
        label="支持设备"
        width="100"
      >
        <template slot-scope="scope">
          <i
            v-for="device of scope.row.devices"
            :key="device"
            class="iconfont"
            :class="{
              'icon-iphone': device === 'mobile',
              'icon-ipad': device === 'pad',
              'icon-pc': device === 'pc',
            }"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="试卷名"
        width="200"
      />
      <el-table-column
        prop="describe"
        width="300"
        label="试卷描述"
      />

      <el-table-column
        label="状态"
        width="100"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="
              scope.row.checkingStatus === 'rejected' &&
                !!scope.row.checkingMessage
            "
            class="item"
            effect="dark"
            :content="scope.row.checkingMessage"
            placement="top"
          >
            <span>{{ scope.row.checkingStatus || "-" | checkStatus }}</span>
          </el-tooltip>
          <span v-else>{{
            scope.row.checkingStatus || "-" | checkStatus
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="发布人"
        width="110"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.publishedBy || "-" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="发布时间"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.publishedAt | dateFormat }}</span>
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        label="操作"
        width="180"
      >
        <template slot-scope="scope">
          <div class="operate">
            <!-- 审核中和审核后不能编辑 -->
            <el-button
              v-if="
                $hasPermission('previewEdit') &&
                  scope.row.checkingStatus !== 'waiting' &&
                  scope.row.checkingStatus !== 'resolved'
              "
              size="small"
              type="text"
              @click="
                $router.push({
                  name: 'previewEdit',
                  params: { courseId: $route.query.courseId },
                  query: { version: scope.row.version },
                })
              "
            >
              {{ $t("编辑") }}
            </el-button>

            <el-button
              v-if="
                $hasPermission('previewDelete') &&
                  scope.row.checkingStatus !== 'waiting' &&
                  scope.row.checkingStatus !== 'resolved'
              "
              size="small"
              type="text"
              @click="deleteVersion(scope.row.version)"
            >
              {{ $t("删除") }}
            </el-button>

            <el-dropdown
              trigger="hover"
              @command="preview"
            >
              <el-button
                size="small"
                type="text"
              >
                {{ $t("预览") }}
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{'version': scope.row.version,'device': 'pad','metalang':'zh-CN'}">
                  <el-button
                    size="small"
                    type="text"
                  >
                    国内
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item
                  v-for="(item,key) in languages"
                  :key="key"
                  :command="{'version': scope.row.version,'device': 'pad','metalang':item.value}"
                >
                  <el-button
                    size="small"
                    type="text"
                  >
                    {{ item.name }}
                  </el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <!-- <el-popover
              placement="bottom"
              width="200"
              trigger="click"
            >
              <qrcode
                v-if="scope.row.httpUrl"
                :text="scope.row.httpUrl"
                :show-text="true"
              />
              <el-button
                slot="reference"
                size="small"
                type="text"
                @click="preview(scope.row.version)"
              >
                {{ $t("预览") }}
              </el-button>
            </el-popover> -->

            <el-button
              v-if="
                $hasPermission('previewCheck') &&
                  scope.row.checkingStatus === 'waiting'
              "
              size="small"
              type="text"
              @click="
                $router.push({
                  name: 'previewCheck',
                  params: { courseId: $route.query.courseId },
                  query: { version: scope.row.version },
                })
              "
            >
              {{ $t("审校") }}
            </el-button>

            <el-button
              v-if="
                $hasPermission('unitTestPublish') &&
                  scope.row.checkingStatus === 'resolved' &&
                  !scope.row.online
              "
              size="small"
              type="text"
              @click="publish(scope.row.version)"
            >
              {{ $t("发布") }}
            </el-button>

            

            <el-dropdown
              trigger="hover"
              @command="rePublish"
            >
              <el-button
                size="small"
                type="text"
              >
                {{ $t("重新发布") }}
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item,key) in languages"
                  :key="key"
                  :command="{'version': scope.row.version,'metalang': item.value}"
                  class="iconfont"
                >
                  <el-button
                    size="small"
                    type="text"
                  >
                    {{ item.name }}
                  </el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-button
              v-if="
                $hasPermission('unitTestCreate') &&
                  scope.row.checkingStatus === 'resolved'
              "
              size="small"
              type="text"
              @click="fork(scope.row.version)"
            >
              {{ $t("复制") }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="forkDialogVisible">
      <fork-preview
        v-if="forkVersion"
        :key="($route.query.courseId || '') + '-' + forkVersion"
        :course-id="$route.query.courseId"
        :version="forkVersion"
        @close="forkClose"
      />
    </el-dialog>

    <el-dialog
      :visible.sync="previewdialogVisible"
      width="240px"
      @close="closePreviewDialog"
    >
      <qrcode
        v-if="currentPreviewUrl"
        :text="currentPreviewUrl"
        :show-text="true"
      />
    </el-dialog>
  </div>
</template>
<style lang="less" scoped>
.controls {
  position: relative;
  .add {
    position: absolute;
    right: 30px;
    bottom: 0;
  }
}

.operate {
  .el-button {
    margin-right: 10px;
  }
}

.offline,
.online {
  width: 15px;
  height: 15px;
  border-radius: 100%;
  border: #8bc34a 1px solid;
}

.online {
  background-color: #8bc34a;
}
</style>
<script>
const debug = require('debug')('ccs:ctrl:unit-test');
import axios from 'axios';
import { find } from 'lodash';
import { noopPromise } from '../utils';
import qrcode from '../components/qrcode';
import forkPreview from '../components/fork_preview';
import textbookCategorySelect from '../components/textbook_category_select';
import {
	getTextbook,
	getTextbookChildren,
	getTextbookParent,
	getTextbookSeries,
	getTextbookCategoryTree,
} from '../service/textbook';

export default {
	components: {
		forkPreview,
		textbookCategorySelect,
		qrcode,
	},
	data() {
		return {
			selectionProps: {
				lazy: true,
				value: 'id',
				label: 'name',
				expandTrigger: 'hover',
				lazyLoad(node, resolve) {
					if (node.value) {
						const textbookId = node.value;
						const level = node.level;
						getTextbookChildren({ textbookId }).then((data) => {
							data.forEach((item) => {
								// 没有子节点
								item.leaf = level + 1 >= 3;
							});

							resolve(data);
						});
					} else {
						resolve();
					}
				},
			},

			forkDialogVisible: false,
			forkVersion: null,

			// 教材分类
			levels: [],
			courseTypeCode: '',
			categoryCode: '',
			textbookVersion: '',
			levelAndCourse: [],
			courseId: null,

			// 试卷版本信息
			previewVersions: [],
			currentPreviewUrl: '',
			previewdialogVisible: false,
			languages: []
		};
	},
	watch: {
		// 如果路由有变化，会再次执行该方法
		'$route.query.courseId': async function (curr, prev) {
			await this.search();
			// if (curr !== prev) {
			//   await this.init();
			// } else {
			//   await this.search();
			// }
		},
	},
	async created() {
		await this.init();
	},
	methods: {
		async init() {
			debug('[init]');
			const { courseId } = this.$route.query;
			if (courseId) {
				const [unit, course] = await Promise.all([
					getTextbookParent({ textbookId: courseId }),
					getTextbook({ textbookId: courseId }),
				]);
				const level = await getTextbookParent({ textbookId: unit.id });

				debug(
					'[init] levelId: %s, unitId: %s, courseId: %s, courseTypeCode: %s, categoryCode: %s, textbookVersion: %s',
					course.id,
					level.id,
					unit.id,
					level.courseTypeCode,
					level.categoryCode,
					level.version
				);

				this.courseTypeCode = level.courseTypeCode;
				this.categoryCode = level.categoryCode;
				this.textbookVersion = level.version;
				this.levelAndCourse = [level.id, unit.id, course.id];
			}
			this.languages = await axios.get('/api/languages');
			await this.search();
		},

		// 单元测试题所有版本
		async search() {
			const { courseId } = this.$route.query;

			if (courseId) {
				const previewVersions = await axios.get(`/api/preview/${courseId}/versions`);
				debug('[search] previewVersions: %o', previewVersions);
				this.previewVersions = previewVersions;
			}
		},

		async selectLevels(levels) {
			debug('[selectLevels]', levels);
			this.levels = levels;
			this.$nextTick(() => {
				this.triggerCascaderValue();
			});
		},

		selectTextbook() {
			const courseId = this.levelAndCourse[2];
			this.$router.replace({ query: { courseId } });
		},

		async deleteVersion(version) {
			const { courseId } = this.$route.query;
			if (!courseId) return;

			await axios.delete(`/api/preview/${courseId}/${version}`);
			await this.search();
		},

		async preview(val) {
			const { courseId } = this.$route.query;
			if (!courseId) return;

			const { version, device,metalang } = val;

			/* eslint no-undef:0 */
			debug('[preview] version: %s', version);
			// const previewVersion = find(this.previewVersions, { version });
			// if (previewVersion.httpUrl) return;

			const urls = await axios.get(`/api/preview/${courseId}/urls`, {
				params: { version },
			});
			let previewUrl = urls.mobile.split('?') ? urls[device].split('?')[0] : '';
			previewUrl = `${previewUrl}?preview=true&metalang=${metalang}`;
			// 替换域名，因为 itextbook.51talk.com 的 cdn 缓存会造成缓存了预览题型的数据
			previewUrl = previewUrl.replace(/^http:\/\/[^/]+/, 'http://api.ccs.51talkjr.com');
			this.currentPreviewUrl = previewUrl;
			this.previewdialogVisible = true;
			// this.$set(previewVersion, 'httpUrl', urls.mobile);
		},
		// 关闭预览dialog时清除数据
		closePreviewDialog() {
			this.currentPreviewUrl = '';
		},

		// 题发布
		async publish(version) {
			const { courseId } = this.$route.query;
			if (!courseId) return;

			await axios.post(`/api/preview/${courseId}/publish`, { version });
			await this.search();
		},

		async rePublish(val){
			const { courseId } = this.$route.query;
			if (!courseId) return;
			const { version, metalang } = val;
			const data = await axios.get('api/paper/metalang/publish', {
				params: { version:version,metalang:metalang,businessid:courseId,category:'preview' },
			});
			if(data.code == 1){
				alert('success');
			}else{
				alert(data.msg);
			}
		},

		async fork(version) {
			this.forkDialogVisible = true;
			this.forkVersion = version;
			debug('[fork] version: %s', version);
		},

		async forkClose(courseId) {
			this.forkDialogVisible = false;
			this.forkVersion = null;
			if (!courseId) return; // 取消

			if (this.$route.query.courseId !== courseId) {
				this.$router.push({ query: { courseId } });
				window.location.reload();
			} else {
				await this.search();
			}
		},

		async triggerCascaderValue() {
			const { courseId } = this.$route.query;
			if (!courseId) return;

			debug('[triggerCascaderValue] courseId: %o', courseId);
			try {
				const el = this.$refs.courseSelectForm.$el.querySelector(
					'.el-cascader > .el-input > input'
				);
				if (el.value) return;

				const [unit, course] = await Promise.all([
					getTextbookParent({ textbookId: courseId }),
					getTextbook({ textbookId: courseId }),
				]);
				const level = await getTextbookParent({ textbookId: unit.id });

				debug(
					'[triggerCascaderValue] name: %s',
					course.name + ' / ' + unit.name + ' / ' + level.name
				);
				el.value = course.name + ' / ' + unit.name + ' / ' + level.name;
			} catch (ignored) {}
		},
	},
};
</script>
